import React, { useState, useContext , useEffect} from "react";
import { tokens } from "../theme";
import {
  Box,
  Button,
  TextField,
  Modal,
  Typography,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useTheme } from "@mui/material";
import { UserContext } from "../UserContext";
import "./CompanyList.css";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const UserRegistration = () => {
  const { role, user_id } = useContext(UserContext);
  const [submitting, setSubmitting] = useState(false);
  const [values, setValues] = useState({
    username: "",
    first_name: "",
    last_name: "",
    role: "",
    password: "",
    confirmPassword: "",
    user_id: user_id,
    notRobot: false, // Change this to boolean
  });
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleBlur = (event) => {
    const fieldName = event.target.name;
    setTouched({ ...touched, [fieldName]: true });
  };

  const handleChange = (event) => {
    const fieldName = event.target.name;
    const newValue =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value; // Handle checkbox value correctly
    setValues({ ...values, [fieldName]: newValue }); // Update state based on field type
  };

  const initialValue = {
    username: "",
    first_name: "",
    last_name: "",
    role: "",
    password: "",
    confirmPassword: "",
    notRobot: false, // Ensure this is false by default
  };

  const validateForm = () => {
    let formErrors = {};
    if (!values.first_name) {
      formErrors.first_name = "First Name is required";
    }
    if (!values.last_name) {
      formErrors.last_name = "Last Name is required";
    }
    if (!values.username) {
      formErrors.username = "Email or Mobile number is required";
    } else if (!isValidEmail(values.username)) {
      formErrors.email = "Invalid email address";
    }
    if (!values.password) {
      formErrors.password = "Password is required";
    }
    if (values.password !== values.confirmPassword) {
      formErrors.confirmPassword = "Passwords do not match";
    }
    if (!values.notRobot) {
      formErrors.notRobot = "Please select the checkbox";
    }
    return formErrors;
  };

  const isValidEmail = (email) => {
    return true;
  };

  const isFormValid = () => {
    const formErrors = validateForm();
    return (
      Object.keys(formErrors).length === 0 &&
      values.first_name &&
      values.last_name &&
      values.username &&
      values.password &&
      values.confirmPassword &&
      values.role &&
      values.notRobot
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formErrors = validateForm();
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      try {
        setSubmitting(true);
        const { notRobot, ...dataToSend } = values;

        const response = await fetch(`/api/register?user_id=${user_id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataToSend),
        });

        if (response.ok) {
          openModal("User created successfully");
        } else {
          openModal("User Registration Failed. Please try again.");
        }
      } catch (error) {
        console.error("An error occurred:", error);
      } finally {
        setSubmitting(false);
      }
    }
  };

  const openModal = (message) => {
    setModalMessage(message);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setValues(initialValue);
  };

  

  return (
    <div className="container">
    <div className="d-flex enquiry-list justify-content-between align-items-center ur-2">
      <Link to="/Dashboard">
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          className="ur-btn-back"
        >
          Back
        </Button>
      </Link>
      <h1 className="text-center mx-auto">Add Employees</h1>
      <Link to="/employeelist">
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          className="ur-btn-list"
        >
          Employee List
        </Button>
      </Link>
    </div>
    <Box className="ur-box-1">
      <div className="ur-div-1">
        <Box className="ur-form-box">
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} className="ur-grid-item">
                <TextField
                  variant="filled"
                  type="text"
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.first_name}
                  name="first_name"
                  error={!!touched.first_name && !!errors.first_name}
                  helperText={touched.first_name && errors.first_name}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} className="ur-grid-item">
                <TextField
                  variant="filled"
                  type="text"
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.last_name}
                  name="last_name"
                  error={!!touched.last_name && !!errors.last_name}
                  helperText={touched.last_name && errors.last_name}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} className="ur-grid-item">
                <TextField
                  variant="filled"
                  type="text"
                  label="Email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.username}
                  name="username"
                  error={!!touched.username && !!errors.username}
                  helperText={touched.username && errors.username}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} className="ur-grid-item">
                <FormControl variant="filled" fullWidth>
                  <InputLabel htmlFor="role-select">Role</InputLabel>
                  <Select
                    labelId="role-select"
                    id="role-select"
                    value={values.role}
                    onChange={handleChange}
                    name="role"
                  >
                    <MenuItem value="Admin">Super Admin</MenuItem>
                    <MenuItem value="Employee">Employee</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} className="ur-grid-item">
                <TextField
                  variant="filled"
                  type="password"
                  label="Password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  name="password"
                  error={!!touched.password && !!errors.password}
                  helperText={touched.password && errors.password}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} className="ur-grid-item">
                <TextField
                  variant="filled"
                  type="password"
                  label="Confirm Password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.confirmPassword}
                  name="confirmPassword"
                  error={!!touched.confirmPassword && !!errors.confirmPassword}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="notRobot"
                      color="primary"
                      checked={values.notRobot}
                      onChange={handleChange}
                    />
                  }
                  label="I am not a robot"
                />
              </Grid>
            </Grid>
            <br />
            <Button
              type="submit"
              variant="contained"
              disabled={submitting || !isFormValid()}
              className="ur-btn-submit"
            >
              {submitting ? "Creating User..." : "Create New User"}
            </Button>
          </form>
        </Box>
      </div>
      <Modal
        open={modalOpen}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box className="ur-modal-box">
          <Typography id="modal-description" sx={{ mt: 4 }}>
            {modalMessage}
          </Typography>
          <br />
          <Button color="secondary" variant="contained" onClick={closeModal}>
            Close
          </Button>
        </Box>
      </Modal>
    </Box>
  </div>
  );
};

export default UserRegistration;
